/**
 * V2AssistantPage (PRP-MCP-10 work item 4): `/assistant`, the one place to
 * connect a chat app. Holds the consent box, connect steps per app, the
 * connection status and, collapsed, the access tokens (all moved out of
 * Settings). Open to free users too: the connect section shows the free
 * allowance with the subscribe and trial links. PRP-MCP-12: below it, the
 * user's own suggestions sent from chat (reference, date, status, reply).
 */
import type { ReactNode } from 'react';

import McpConnectSection from '../components/McpConnectSection';
import YourSuggestions from '../components/YourSuggestions';
import { Card } from '../components/ui/card';

/** Section card matching the Settings page's frame. */
function Frame({ title, sub, children }: { title: string; sub?: string; children: ReactNode }) {
  return (
    <Card className="p-0">
      <div className="border-b border-[var(--bd-subtle)] px-[18px] pb-[12px] pt-[16px]">
        <h2 className="m-0 text-[11px] font-[650] uppercase tracking-[.06em] text-[var(--tx-lo)]">
          {title}
        </h2>
        {sub && <p className="mb-0 mt-1 text-[12px] text-[var(--tx-faint)]">{sub}</p>}
      </div>
      <div className="p-[18px] max-md:p-3">{children}</div>
    </Card>
  );
}

/** The AI Assistant page. */
export default function V2AssistantPage() {
  return (
    <div className="mx-auto w-full max-w-[760px] px-6 py-8 max-md:px-4" data-testid="assistant-page">
      <h1 className="m-0 mb-4 text-[22px] font-[620] tracking-[-0.01em] text-[var(--tx-hi)]">
        AI Assistant
      </h1>
      <McpConnectSection frame={Frame} />
      <div className="mt-4">
        <YourSuggestions frame={Frame} />
      </div>
    </div>
  );
}
